'use client'

import { useTheme } from '@/components/ThemeProvider'
import { useState, useEffect } from 'react'
import Link from 'next/link'

type LogoLocation = 'header' | 'footer' | 'login' | 'dashboard'

export function Logo({ 
  className,
  location = 'header',
  forceDark = false, 
  forceWhite = false,
  link = true 
}: { 
  className?: string
  location?: LogoLocation
  forceDark?: boolean
  forceWhite?: boolean
  link?: boolean
}) {
  const { theme } = useTheme()
  const [config, setConfig] = useState<any>(null)

  useEffect(() => {
    fetch('/api/site-content').then(r => r.json()).then(d => {
      if (d?._logo) setConfig(d._logo)
    }).catch(() => {})
  }, [])

  const darkUrl = config?.darkUrl || '/logo-dark.png'
  const whiteUrl = config?.whiteUrl || '/logo-white.png'
  
  // Dashboard is always 14px — independent of header/footer config
  const sizeMap: Record<LogoLocation, number> = {
    header: config?.headerSize || 48,
    footer: config?.footerSize || 48,
    login: config?.loginSize || 56,
    dashboard: 14,
  }
  const pixelSize = sizeMap[location]

  const src = forceWhite 
    ? whiteUrl 
    : forceDark 
    ? darkUrl 
    : theme === 'dark' ? whiteUrl : darkUrl

  const img = <img src={src} alt="Preplix" className={`transition-opacity duration-300 ${config !== null ? 'opacity-100' : 'opacity-0'} ${className || ''}`} style={className ? undefined : { height: `${pixelSize}px` }} />

  if (link) {
    return <Link href="/">{img}</Link>
  }
  return img
}
